import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import store from "./store";
import { MantineProvider } from "@mantine/core";
import { Chart as ChartJS, registerables } from "chart.js";
import "@mantine/core/styles.css";

/*import "./i18n";*/

ChartJS.register(...registerables);

const applicationFontFamily =
  '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji"';

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <React.Fragment>
      <MantineProvider
        theme={{
          fontFamily: applicationFontFamily,
          headings: { fontFamily: applicationFontFamily },
        }}
      >
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </MantineProvider>
    </React.Fragment>
  </Provider>
);
